import { getS3ImgUrl } from "../services/env-helper";

const entityTypes = {
  loan_against_property: {
    type: "loan_against_property",
    imgSrc: getS3ImgUrl("/b2c/overview/loan-againt-property.png"),
    title: "Loan against property",
  },
  home_loan: {
    type: "home_loan",
    title: "Home loan",
    imgSrc: getS3ImgUrl("/b2c/overview/home-loan.webp"),
  },
  credit_card: {
    type: "credit_card",
    title: "Credit card",
    imgSrc: getS3ImgUrl("/b2c/overview/credit-card.webp"),
    disabledBreFlow: true,
    noLoanDetails: true,
    noIncome: true,
    noAddress: true,
  },
  credit_score: {
    type: "credit_score",
    title: "Credit score",
    imgSrc: getS3ImgUrl(
      "/b2c/cibil-score/offering-instant-free-cibil-score-check-online.webp"
    ),
  },
  personal_loan: {
    type: "personal_loan",
    title: "Personal loan",
    imgSrc: getS3ImgUrl("/b2c/overview/personal-loan.webp"),
    alt: "pl",
  },
  business_loan: {
    type: "business_loan",
    title: "Business loan",
    imgSrc: getS3ImgUrl("/b2c/overview/business-loan.webp"),
  },
  education_loan: {
    type: "education_loan",
    title: "Education loan",
    imgSrc: getS3ImgUrl("/b2c/overview/education-loan.png"),
    disabledBreFlow: true,
  },
  car_loan: {
    type: "car_loan",
    title: "Car loan",
    imgSrc: getS3ImgUrl("/b2c/overview/car-loan.webp"),
    disabledBreFlow: true,
  },
  used_car_loan: {
    type: "used_car_loan",
    title: "Userd car loan",
    imgSrc: getS3ImgUrl("/b2c/overview/car-loan.webp"),
    disabledBreFlow: true,
  },
  car_refinance: {
    type: "car_loan",
    title: "Car loan",
    imgSrc: getS3ImgUrl("/b2c/overview/car-loan.webp"),
    disabledBreFlow: true,
  },
  gold_loan: {
    type: "gold_loan",
    title: "Gold loan",
    imgSrc: getS3ImgUrl("/b2c/overview/gold-loan.png"),
    disabledBreFlow: true,
  },
  bill_payment: {
    type: "bill_payment",
    title: "Bill payment",
    bannerImg: getS3ImgUrl("/b2c/integration/paying-bills-bbps-concept.webp"),
  },
  machinery_loan: {
    type: "machinery_loan",
    title: "Machinery Loan",
    imgSrc: getS3ImgUrl(
      "/b2c/machinery-loan/transform-your-business-with-machinery-loan.jpeg"
    ),
  },
  dummy_bre: {
    type: "dummy_bre",
    title: "Dummy BRE",
    imgSrc: getS3ImgUrl(
      "/b2c/machinery-loan/transform-your-business-with-machinery-loan.jpeg"
    ),
  },
  credit_score_report_crif: {
    type: "credit_score",
    title: "Credit Score Report",
    subType: "crif",
  },
  credit_score_report: {
    type: "credit_score_report",
    title: "Credit Score Report",
    imgSrc: getS3ImgUrl(
      "/b2c/machinery-loan/transform-your-business-with-machinery-loan.jpeg"
    ),
  },
  credit_score_report_cibil: {
    type: "credit_score",
    subType: "cibil",
    title: "Credit Score Report",
  },
  loan_types: {
    type: "loan_type",
    title: "Loan and Credit Cards",
    imgSrc: getS3ImgUrl("/b2c/overview/personal-loan.webp"),
    imgSrc: getS3ImgUrl(
      "/b2c/machinery-loan/transform-your-business-with-machinery-loan.jpeg"
    ),
  },
  solar_loan: {
    type: "solar_loan",
    title: "Solar Loan",
    imgSrc: getS3ImgUrl(
      "/b2c/solar-loan/transform-your-business-with-solar-loan.webp"
    ),
  },
};

const entityTypesArr = Object.keys(entityTypes).join(",");

const clientTypes = {
  b2c_web: "b2c",
  b2b_web: "b2b",
  b2b_app: "b2b",
  b2c_app: "b2c",
  crm_web: "crm_web",
};

const clientTypesArr = Object.keys(clientTypes).join(",");

const eventTypes = {
  sdk_invoked: "sdk_invoked",
  sdk_closed: "sdk_closed",
  sdk_initiated: "sdk_initiated",
  sdk_redirect: "sdk_redirect",
};

const productTypeIds = {
  check_eligibility: 0,
};

const picklistKeys = {
  address: "Address",
  business_type: "Business Type",
};

const picklistKeysAlias = {
  residential_addess: "residential_addess",
  office_address: "office_address",
};

const isB2B = (clientType) => clientType === clientTypes.b2b_web;

export {
  entityTypes,
  entityTypesArr,
  clientTypes,
  clientTypesArr,
  eventTypes,
  productTypeIds,
  picklistKeys,
  picklistKeysAlias,
  isB2B,
};
